<template>
  <v-container fluid class="d-flex flex-column justify-center height-100-percent">
    <v-row align-content="center">
      <v-col
          cols="12"
          sm="10" offset-sm="1"
          md="8" offset-md="2"
          lg="6" offset-lg="3"
          xl="4" offset-xl="4"
      >
        <v-card elevation="1">
          <v-card-title>
            <img src="/images/acc-logo-rgb.png" alt="America's Call Center" height="100" width="157"
                 class="mx-auto">
          </v-card-title>
          <v-card-text>
            <form @keyup.enter="submit">
              <v-text-field
                  v-model="username"
                  id="username"
                  :error-messages="usernameErrors"
                  label="Username"
                  required
                  filled
                  @blur="$v.username.$touch()"
              ></v-text-field>
              <v-text-field
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  :type="showPassword ? 'text' : 'password'"
                  v-model="password"
                  id="password"
                  :error-messages="passwordErrors"
                  label="Password"
                  required
                  filled
                  @blur="$v.password.$touch()"
              ></v-text-field>
                <!--Forgot password?-->
              <v-btn
                  color="primary"
                  class="mb-1 px-1"
                  style="text-transform: none"
                  text
                  @click="forgotPassword"
              >
                Forgot Password?
              </v-btn>
              <v-btn
                  class="mr-4"
                  @click="submit"
                  block
                  color="primary"
                  :disabled="submitted || $v.$invalid"
              >
                submit
              </v-btn>
            </form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {minLength, required} from 'vuelidate/lib/validators'
import {mapMutations} from 'vuex'

export default {
  mixins: [validationMixin],

  validations: {
    username: {
      required,
      minLength: minLength(3)
    },
    password: {
      required
    },
  },

  name: 'Login',
  data() {
    return {
      submitted: false,
      username: '',
      password: '',
      showPassword: false,
    }
  },
  computed: {
    usernameErrors() {
      const errors = []
      if (! this.$v.username.$dirty) return errors
      ! this.$v.username.minLength && errors.push('Username must be at least 3 characters long')
      ! this.$v.username.required && errors.push('Username is required.')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (! this.$v.password.$dirty) return errors
      ! this.$v.password.required && errors.push('Password is required')
      return errors
    },
  },
  methods: {
    ...mapMutations([
      'setLoggedIn', 'setShowSnackbar', 'setPlatform',
      'setSnackbarMsg', 'setSnackbarColor', 'setShowWhatsNew'
    ]),
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.submitted = true
      this.login().catch(() => this.clear())
    },
    async login() {
      await this.$axios.get('/sanctum/csrf-cookie')

      const response = await this.$axios.post('/login', {
        username: this.username,
        password: this.password
      })

      const user = response.data;

      this.setLoggedIn(user)
      this.setShowWhatsNew(user.show_whats_new)

      this.$router.push({name: 'inspections'}).catch(() => {})
    },
    clear() {
      this.username = ''
      this.password = ''
      this.submitted = false
    },
    forgotPassword() {
      this.$router.push({name: 'forgot-password'})
    }
  },
  mounted() {
    // If there is no 401, then the user is logged in. So, let's boot them over to the main page
    this.$axios.get('/api/user')
        .then((res) => {
          this.setLoggedIn(res.data)
          return this.$router.replace({name: 'inspections'}).catch((e) => Promise.reject(e))
        })
        .catch(() => {})
  },
  created() {
    const platform = localStorage.getItem('platform') ?? 'desktop'
    this.setPlatform(platform)
  },
}
</script>

<style>
.height-100-percent {
  height: 100%;
}
</style>